var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.translatedHelpText
    ? _c(
        "div",
        {
          staticClass:
            "text-help d-print-none form-text text-muted d-flex flex-nowrap",
          class: [
            _vm.helpClass,
            this.truncateText ? "align-items-center" : "align-items-start",
          ],
        },
        [
          _c("i", {
            class: ["fas fa-info-circle pr-1", { "pt-1": !this.truncateText }],
            attrs: {
              "data-toggle": "tooltip-city",
              "data-placement": "right",
              title: _vm.translatedHelpText,
            },
          }),
          _vm._v(" "),
          !_vm.onlyIcon
            ? _c("span", {
                class: _vm.helpFieldClass,
                domProps: { innerHTML: _vm._s(_vm.translatedHelpText) },
              })
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }